module.exports = __webpack_public_path__ + "img/2.b03b52d6.jpg";